export default __webpack_public_path__ + "static/media/gallery-22.5c0681b8.jpg";